'use client';
import { useEffect } from 'react';
import { useProperties } from '@/context/properties-context';

export function useScrollToTop() {
	const {
		properties: { page },
	} = useProperties();

	useEffect(() => {
		window.scrollTo({ top: 0, behavior: 'smooth' });
	}, [page]);
}
